import numeral from 'numeral';

/**
 * Formatte un nombre en un format lisible.
 * @param {number} number - Le nombre à formater.
 * @return {string} Le nombre formaté.
 */
export function fNumber(number) {
  return numeral(number).format();
}

/**
 * Convertit un nombre en format monétaire.
 * @param {number} number - Le nombre à convertir (en centimes).
 * @return {string} Le nombre en format monétaire avec séparateurs européens.
 */
export function fCurrency(number) {
  // Diviser par 100 pour convertir les centimes en euros
  const euros = number / 100;

  // Formater le nombre avec 'numeral', en utilisant 2 décimales
  let formattedNumber = numeral(euros).format('0,0.00');

  // Remplacer les séparateurs anglais (virgule pour milliers et point pour décimales)
  // par des séparateurs européens (espace pour milliers et virgule pour décimales)
  formattedNumber = formattedNumber.replace(/,/g, ' ').replace(/\./g, ',');

  // Ajouter le symbole € et retourner le résultat
  return formattedNumber + ' €';
}

export function eCurrency(number) {
  // Formater le nombre avec 'numeral', en utilisant 2 décimales
  let formattedNumber = numeral(number).format('0,0.00');

  // Remplacer les séparateurs anglais (virgule pour milliers et point pour décimales)
  // par des séparateurs européens (espace pour milliers et virgule pour décimales)
  formattedNumber = formattedNumber.replace(/,/g, ' ').replace(/\./g, ',');

  // Ajouter le symbole € et retourner le résultat
  return formattedNumber + ' €';
}

/**
 * Convertit un nombre en pourcentage.
 * @param {number} number - Le nombre à convertir.
 * @return {string} Le pourcentage.
 */
export function fPercent(number) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';
  return result(format, '.0');
}

/**
 * Convertit un grand nombre en un format abrégé.
 * @param {number} number - Le nombre à convertir.
 * @return {string} Le nombre en format abrégé.
 */
export function fShortenNumber(number) {
  const format = number ? numeral(number).format('0.00a') : '';
  return result(format, '.00');
}

/**
 * Formatte un nombre pour les données (ex: octets en KB, MB, etc.).
 * @param {number} number - Le nombre à formater.
 * @return {string} Le nombre formaté pour les données.
 */
export function fData(number) {
  const format = number ? numeral(number).format('0 b') : '';
  return format;
}

/**
 * Fonction d'assistance pour nettoyer le formatage si nécessaire.
 * @param {string} format - Le format à nettoyer.
 * @param {string} [key='.00'] - La clé à utiliser pour le nettoyage.
 * @return {string} Le format nettoyé.
 */
function result(format, key = '.00') {
  const isInteger = format.includes(key);
  return isInteger ? format.replace(key, '') : format;
}
